import { Map } from 'immutable';

import Api from '../api';

import Campaign from './model';
import { addAction, addMultipleAction, updateAction } from './actions';

export default class CampaignApi {
  private static readonly CAMPAIGNS_URL = 'api/campaigns';

  static fetchAll() {
    return Api.get<Campaign[]>(this.CAMPAIGNS_URL).map((campaigns) =>
      addMultipleAction(
        Map(campaigns.map((campaign: any) => [campaign.id, new Campaign(campaign)]))
      )
    );
  }

  static fetch(id: string) {
    return Api.get<Campaign>(`${this.CAMPAIGNS_URL}/${id}`).map((campaign) =>
      addAction(new Campaign(campaign))
    );
  }

  static create(data: any) {
    return Api.post<Campaign>(this.CAMPAIGNS_URL, data).map((campaign) =>
      addAction(new Campaign(campaign))
    );
  }

  static update(id: string, data: any) {
    return Api.patch<Campaign>(`${this.CAMPAIGNS_URL}/${id}`, data).map((campaign) =>
      updateAction(new Campaign(campaign))
    );
  }

  // static delete(id) {
  //   return Api.delete(`api/forms/${id}`).map(() => removeAction(id));
  // }
}
